<template>
  <div class="filter-list-image-item">
    <div 
      class="filter-list-image-container"
      @mouseover="toggleImgOverlay(true)" 
      @mouseleave="toggleImgOverlay(false)"
    >
      <v-img v-if="item.data != null" :src="item.data"></v-img>
      <v-img v-else :src="prefixServerImgPath(`${item.examinationID}/${item.file}`)"></v-img>

      <div
        class="filter-list-image-item-actions-overlay"
        v-if="showImgOverlay"
      >
        <v-btn flat icon dark @click="downloadImg(`${item.examinationID}/${item.file}`)">
          <v-icon>cloud_download</v-icon>
        </v-btn>
        <v-btn flat icon dark @click="$emit('deleteImg', item.id)">
          <v-icon>delete_outline</v-icon>
        </v-btn>
      </div>
    </div>

    <div class="filter-list-image-actions">
      <div class="left pic-number">P{{ number }}</div>
      <div class="landmark" @click="showLandmarkSelect">
        <v-btn v-if="item.landmarkID === 0" icon flat small class="action-btn">
          <v-icon>location_on</v-icon>
        </v-btn>
        <div v-else class="text">{{ landmarkText }}</div>
      </div>
      <!--<number-select-input 
        :data="item.cm"
        :float="false"
        :unit="'cm'"
        @change="$emit('change', { newValue: $event })"
      ></number-select-input>-->
      <font style="color: #FFF;">{{ Number(item.cm) > 0 ? item.cm + ' cm' : '' }}</font>
      <v-btn icon flat small class="action-btn print" @click="$emit('imgStatusChange')">
        <v-icon v-if="Number(item.status) == 0">print</v-icon>
        <v-icon v-else>check</v-icon>
      </v-btn>

      <v-btn 
        icon flat small dark 
        :outline="Number(findingIndex) !== 0" 
        class="action-btn finding" 
        @click="showFindingSelect"
      >
        <v-icon v-if="Number(findingIndex) === 0">label</v-icon>
        <span v-else>{{ findingIndex }}</span>
      </v-btn>
    </div>
    <div 
      class = "tag"
      v-if="item.tag && item.tag.length > 0">
      {{ item.tag.toUpperCase() }}
    </div>

    <div 
      v-show="showFindingSelectOptions || showLandmarkSelectOptions"
      class="filter-list-image-item-select-overlay"
    >
      <v-select 
        v-show="showFindingSelectOptions"
        ref="findingSelectElm" 
        class="select" 
        :items="findingSelectItems"
        @blur="onBlur('Finding')"
        @change="findingChange"
      ></v-select>

      <v-select
        v-show="showLandmarkSelectOptions"
        ref="landmarkSelectElm"
        class="landmark"
        :items="landmarkSelectItems"
        @blur="onBlur('Landmark')"
        @change="landmarkChange"
      ></v-select>
    </div>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  import common from '@/utils/common'
  const API_URL = process.env.VUE_APP_API_URL

  export default {
    name: 'ScreenshotImageItem',

    props: {
      item: {
        type: Object,
        required: true
      },

      findingSelectItems: {
        type: Array,
        required: true
      },

      landmarkSelectItems: {
        type: Array,
        required: true
      },

      landmarkText: {
        type: String,
        required: false
      },
      findingIndex: {
        type: [String, Number],
        required: false
      },
      number: {
        type: Number,
        required: true
      }
    },

    data () {
      return {
        showImgOverlay: false,
        showFindingSelectOptions: null,
        showLandmarkSelectOptions: null,
      }
    },

    computed: {
      ...mapGetters('examinations', [
        'getExaminationData',
        'getExaminationTypeList',
        'getPatient'
      ])
    },

    methods: {
      toggleImgOverlay (boolean) {
        this.showImgOverlay = boolean
      },
      toDataURL(url) {
        return fetch(url).then((response) => {
          return response.blob();
        }).then(blob => {
          return URL.createObjectURL(blob);
        });
      },

      async downloadImg (path) {
        const url = this.prefixServerImgPath(path)
        const filename = `${common.fileRule(this.getExaminationData, this.getExaminationTypeList, this.getPatient)}_${url.replace(/^.*[\\\/]/, '')}`;
        const a = document.createElement("a");
        a.href = await this.toDataURL(url);
        a.download = filename;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
      },

      prefixServerImgPath(path) {
        return `${API_URL}/public/upload/image/${path}`
      },

      showLandmarkSelect () {
        const selectElm = this.$refs.landmarkSelectElm.$el.querySelectorAll('.v-select__selections input')[0]
        selectElm.click()

        this.showLandmarkSelectOptions = !this.showLandmarkSelectOptions
      },

      showFindingSelect () {
        const selectElm = this.$refs.findingSelectElm.$el.querySelectorAll('.v-select__selections input')[0]
        selectElm.click()

        this.showFindingSelectOptions = !this.showFindingSelectOptions
      },

      landmarkChange ($event) {
        this.$emit('landmarkChange', $event)
        this.$refs.landmarkSelectElm.blur()
      },

      findingChange ($event) {
        this.$emit('findingChange', $event)
        this.$refs.findingSelectElm.blur()
      },

      onBlur (type) {
        this[`show${type}SelectOptions`] = !this[`show${type}SelectOptions`]
      }
    }
    }
</script>
<style lang="scss">
.filter-group-container .filter-list-image-actions {

  .left.pic-number {
    margin: 5px;
    height: calc(100% - 10px);
    text-align: center;
    padding-top: 3px;
    color: white;
    border: 1px solid white;
    width: 55px;
  }

  .landmark {
    overflow: hidden;
    width: 100%;
    .text { 
      color: white;
      text-overflow: ellipsis;
      overflow: hidden;
    }
  }

  .v-btn--icon.v-btn--small {
    margin: 3px;
  }
}
.filter-list-image-item{
  .tag{
    background: #fbb000;
    color: #44362d;
    text-align: center;
    font-size: 11px;
    font-weight: bold;
    padding: 2px;
  }
}
</style>